export default __webpack_public_path__ + "static/media/mobile.ff578fb0.jpg";